import { Component, OnInit } from '@angular/core';
import { RestService } from '../services/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { priceComponent } from '../shared/components/price/price.component';
import { UnlockButtonComponent } from '../shared/components/unlock-button/unlock-button.component';
import { loaderComponent } from '../shared/components/loader/loader.component';
import { SessionService } from '../services/session.service';
import { PaymentCodeService } from '../services/payment-code.service';
import { StorageService } from '../services/storage.service';
import { TranslationService } from '../services/translation.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { ErrorReportingService } from '../services/error-reporting.service';
import { StoreBillingService } from '../services/store-billing.service';

@Component({
  selector: 'app-initial-results',
  standalone: true,
  imports: [
    priceComponent,
    UnlockButtonComponent,
    loaderComponent,
    TranslatePipe,
  ],
  templateUrl: './initial-results.component.html',
  styleUrl: './initial-results.component.scss',
})
export class InitialResultsComponent implements OnInit {
  processedImages: {
    front?: string;
  } = {};
  showLoader = true;
  error: string | null = null;
  errorCode: number | null = null;

  scanId: string;
  isProcessing = false;
  paymentStatus: string = 'pending';

  constructor(
    private restService: RestService,
    private route: ActivatedRoute,
    public storageService: StorageService,
    private paymentCodeService:PaymentCodeService,
    public sessionService: SessionService,
    private router: Router,
    public translationService: TranslationService,
    private reporter: ErrorReportingService,
    private storeBilling: StoreBillingService,
  ) {
    this.scanId = this.route.snapshot.params['scanId'];
  }

  async ngOnInit() {
    try {
      const response: any = await this.restService.request({
        path: `initial-result/${this.scanId}`,
        method: 'POST',
        throwError: true,
      });

      this.showLoader = false;
      this.processedImages = response.images;
      await this.paymentCodeService.saveCodeAndFetchPrice(
        response.paymentCode || this.storageService.getPaymentCode(),
        this.scanId,
      );

    } catch (error: any) {
      this.showLoader = false;
      console.error('Failed to fetch initial results:', error);
      // 402 is the expected "needs payment → full-results" redirect, not a fault.
      if (error?.status !== 402) {
        this.reporter.report(
          `initial-results failed status=${error?.status} code=${error?.error?.code || ''}`,
          'results',
        );
      }

      // Set error code
      this.errorCode = error.error?.code || error.status;

      // Handle different error cases
      if (error.error?.code === 404) {
        this.error =
          error.error.message ||
          this.translationService.translate('initialResults.error.scanNotFound');
        return;
      }

      if (error.status === 402) {
        return this.router.navigate(['/app/full-results', this.scanId]);
      }

      if (error.error?.code === 500) {
        if (error.error?.error === 'Scan not completed') {
          return this.router.navigate(['/app/test', this.scanId]);
        }
        this.error = this.translationService.translate(
          'initialResults.error.unexpectedNotified',
        );
        return;
      }

      this.error =
        error.error?.message ||
        this.translationService.translate('initialResults.error.unexpected');
    }
  }

  async createCheckoutSession() {
    // if (this.loginService.isAdmin()) {
    //   return await this.router.navigateByUrl(
    //     `/app/full-results/${this.scanId}`,
    //   );
    // }
    if (this.isProcessing) return;
    if (this.storeBilling.enabled) {
      return this.router.navigate(['/app/payment'], { queryParams: { scanId: this.scanId } });
    }

    this.isProcessing = true;
    this.reporter.logEvent('payment.order.start', { source: 'initial-results' });
    try {
      const response: any = await this.restService.request({
        path: 'payment/create-paypal-order',
        method: 'POST',
        body: {
          scanId: this.scanId,
          planType: 'single',
          origin: window.location.origin,
        },
      });

      if (response.error?.message === 'Order already paid') {
        return this.router.navigate(['/app/full-results', this.scanId]);
      }

      if (response.approvalUrl) {
        this.reporter.logEvent('payment.order.ok', { source: 'initial-results' });
        window.location.href = response.approvalUrl;
      } else {
        console.error('No PayPal approval URL received');
        this.reporter.report('payment order: no approval URL received', 'payment');
      }
    } catch (error) {
      console.error('Failed to create PayPal checkout session:', error);
      this.reporter.report(error, 'payment');
    } finally {
      this.isProcessing = false;
    }
  }

  navigateToDashboard() {
    console.log('InitialResultsComponent: navigating to dashboard');
    this.router.navigate(['/app/user-account']);
  }
}
